<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M21.0002 12.6247C21.2924 12.2595 21.2924 11.7405 21.0002 11.3753L15.2809 4.22609C14.6904 3.48795 13.5 3.9055 13.5 4.85078V8.5C13.5 8.77614 13.2786 8.99884 13.0029 9.01502C9.88854 9.19784 4.08295 11.1225 3.13302 18.761C3.06709 19.2911 3.9094 19.5607 4.254 19.1525C5.69017 17.4512 8.45104 15.1668 12.9972 15.0087C13.2732 14.9991 13.5 15.2239 13.5 15.5V19.1492C13.5 20.0945 14.6904 20.5121 15.2809 19.7739L21.0002 12.6247Z"
		stroke="currentColor"
		stroke-width="1.5"
	/>
</svg>
